import React from 'react';
import styled, { css } from 'styled-components';

import { media } from '@/utils/mixin';
import { useTypedSelector } from '@/store/store';
import { selectCarDetailedBanner } from '@/store/reducers/banners';
import DetailedCarBanner from '@/components/DetailedCarBanner';

function AdBanner() {
  const bannerData = useTypedSelector(selectCarDetailedBanner);

  if (!bannerData.banner) {
    return null;
  }

  const { image, imageMobile, url, isNewTab } = bannerData.banner;

  if (!image?.url) {
    return null;
  }

  return (
    <Component>
      <DetailedCarBanner
        image={image}
        imageMobile={imageMobile ?? image}
        url={url}
        isNewTab={isNewTab}
      />
    </Component>
  );
}

export default AdBanner;

const Component = styled.div`
  margin-top: 56px;

  ${media.mobile(css`
    margin: 40px 0;
  `)}
`;
